import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function Empathy() {
  const { t } = useTranslation('homepage');
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.2);

  return (
    <section
      id="empathy"
      className="bg-slate-primary py-20 md:py-28 lg:py-32"
    >
      <div
        ref={ref}
        className={`max-w-4xl mx-auto px-4 md:px-6 text-center transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <div className="w-16 h-1 bg-copper mx-auto mb-8 rounded-full" />
        <h2 className="font-manrope font-bold text-white text-2xl md:text-3xl lg:text-4xl xl:text-5xl leading-tight mb-8">
          {t('empathy_h2')}
        </h2>
        <p className="text-white/80 text-base md:text-lg lg:text-xl leading-relaxed max-w-3xl mx-auto">
          {t('empathy_text')}
        </p>
        <div className="mt-8 text-3xl">❄️</div>
      </div>
    </section>
  );
}